<template>
  <div ref="trsFormFeedback">
    <b-alert
      show
      variant="success"
      v-dynamic-content="{ rawText: trsFormContent.formFeedback }"
    ></b-alert>
  </div>
</template>

<script>
import trsFormContent from '@/components/quotes/trsForm/trsFormContent'

export default {
  name: 'TrsFormSentAlert',
  computed: {
    trsFormContent() {
      return trsFormContent(this.content, this.$store.getters.trsFormSentMode)
    },
  },
  mounted() {
    if (this.$refs.trsFormFeedback) {
      const topBody = document.body.getBoundingClientRect().top
      const topEl = this.$refs.trsFormFeedback.getBoundingClientRect().top

      const position = topEl - topBody - 150
      this.$store.commit('SET_SCROLL_POSITION', position)
    }
  },
}
</script>
